import React, { Component } from "react";
import PropTypes from "prop-types";

class Errors extends Component {
  static propTypes = { errors: PropTypes.array };
  render() {
    const self = this;
    const errors = self.props.errors;
    if (!errors || errors.length < 1) {
      return null;
    }
    return (
      <div className="alert alert-danger">
        <ul className="mb-0 text-danger font-weight-bold">
          {errors.map((error, i) => (
            <li key={`error-${i}`}>{error.message}</li>
          ))}
        </ul>
      </div>
    );
  }
}
export default Errors;
